import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import seagullexterior1 from '../images/seagull-sg-1.jpg';
import seagullexterior2 from '../images/seagull-sg-2.jpg';
import seagullexterior3 from '../images/seagull-sg-3.jpg';
import seagullexterior4 from '../images/seagull-sg-4.jpg';
import seagullexterior5 from '../images/seagull-sg-5.png';
import seagullexterior6 from '../images/seagull-sg-6.png';

function ExteriorSeagull() {
  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <Helmet>
        <title>
          Eksterior BYD Atto1 2025 - Desain Futuristik Harga Terjangkau | BYD
          BSD Serpong
        </title>
        <meta
          name='description'
          content='Lihat detail eksterior BYD Atto1 2025 di BYD BSD Serpong. Desain stylish dan aerodinamis, cocok untuk kota modern. Temukan juga Harga Denza D9 dan Harga Sealion 7!'
        />
        <meta
          name='keywords'
          content='BYD BSD Serpong, Harga Atto1, Harga Denza D9, Harga Sealion 7, BYD Atto1 2025, Mobil Listrik Murah Indonesia'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/eksterior-byd-atto1'
        />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        🔍 Eksterior BYD Atto1 2025: Desain Mungil, Gaya Futuristik
      </Typography>

      <Typography
        variant='body1'
        paragraph
        sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
      >
        Kalau kamu mencari mobil listrik mungil dengan desain modern dan harga
        terjangkau, <strong>BYD Atto1</strong> adalah jawabannya.
        Diperkenalkan sebagai salah satu mobil listrik paling diminati tahun
        2025, Atto1 tidak hanya tampil elegan dari sisi interior, tetapi juga
        sangat memesona dari sisi eksterior. Lewat artikel ini, kami akan
        membahas detail eksterior BYD Atto1 dari segala sisi – mulai dari
        fascia depan, siluet samping, hingga bagian belakang yang futuristik.
      </Typography>

      <Grid container spacing={4} sx={{ my: 4 }}>
        {[
          {
            img: seagullexterior1,
            caption: 'Tampilan depan Atto1: tajam, tegas, dan kompak.',
          },
          {
            img: seagullexterior2,
            caption: 'Tampilan frontal penuh dengan aura sporty & urban.',
          },
          {
            img: seagullexterior3,
            caption:
              'Bagian belakang menonjolkan karakter modern, lengkap dengan spoiler.',
          },
          {
            img: seagullexterior4,
            caption: 'Detail pelek 15 inci yang stylish dan efisien.',
          },
          {
            img: seagullexterior5,
            caption: 'Siluet samping yang aerodinamis dan ergonomis.',
          },
          {
            img: seagullexterior6,
            caption: 'Tampilan belakang dengan lampu LED tipis memanjang.',
          },
        ].map((item, idx) => (
          <Grid item xs={12} sm={6} key={idx}>
            <Paper sx={{ p: 2, borderRadius: 2 }}>
              <Box
                component='img'
                src={item.img}
                alt={item.caption}
                sx={{ width: '100%', borderRadius: 2, mb: 1 }}
              />
              <Typography variant='body2' color='textSecondary'>
                {item.caption}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🚗 Desain Aerodinamis & Kompak untuk Kota Modern
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Eksterior Atto1 menampilkan dimensi mungil yang sangat cocok untuk
          kebutuhan urban. Dengan panjang sekitar 3.78 meter dan lebar 1.71
          meter, mobil ini sangat mudah diparkir dan lincah di jalan sempit.
          Desainnya menonjolkan garis-garis tajam, headlamp LED sipit, serta
          gril minimalis yang memberikan kesan futuristik ala mobil masa depan.
          Bagian bawah bumper dirancang dengan aksen sport yang tegas.
        </Typography>

        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Tidak hanya itu, bagian samping dilengkapi fender tebal yang
          memperkuat kesan tangguh. Pelek 15 inci berwarna gelap memberikan
          kontras menarik dengan warna bodi cerah. Rear spoiler di bagian atas
          belakang membuatnya tampak lebih sporty, sedangkan lampu belakang LED
          berbentuk garis horizontal menciptakan identitas visual yang khas dari
          BYD.
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          🌈 Pilihan Warna Cerah & Berani
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Salah satu daya tarik terbesar dari Atto1 adalah pilihan warnanya.
          Varian kuning lime seperti pada gambar di atas sangat menarik
          perhatian dan memberi kesan energik. Warna ini menjadi favorit di
          kalangan Gen Z dan milenial. Selain itu, tersedia pula warna putih,
          pink, biru muda, dan hitam. Setiap warna dibuat dengan finishing gloss
          yang mencerminkan cahaya dengan indah, membuat mobil ini selalu
          terlihat segar.
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          📊 Spesifikasi Dimensi Eksterior BYD Atto1
        </Typography>
        <ul style={{ fontSize: '1.1rem', lineHeight: 2 }}>
          <li>Panjang: 3.780 mm</li>
          <li>Lebar: 1.715 mm</li>
          <li>Tinggi: 1.540 mm</li>
          <li>Jarak sumbu roda: 2.500 mm</li>
          <li>Pelek: Alloy 15” dengan ban hemat energi</li>
          <li>Ground clearance: ± 120 mm</li>
        </ul>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          💰 Harga BYD Atto1 & Perbandingan dengan Denza D9 & Sealion 7
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          <strong>Harga Atto1</strong> mulai dari sekitar{' '}
          <strong>Rp150 juta</strong>, menjadikannya mobil listrik paling
          terjangkau di Indonesia saat ini. Sebagai perbandingan,{' '}
          <strong>Harga Denza D9</strong> berada di kisaran Rp950 juta dengan
          fitur premium dan kabin luas, sedangkan{' '}
          <strong>Harga Sealion 7</strong> ada di sekitar Rp719 juta dengan
          performa tinggi dan teknologi AWD.
        </Typography>
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.9 }}>
          Jadi, bila kamu ingin masuk ke dunia EV dengan budget hemat tanpa
          mengorbankan style dan teknologi, <strong>Atto1</strong> adalah
          pilihan yang sangat tepat.
        </Typography>
      </Box>

      <Paper
        sx={{
          p: 4,
          mt: 8,
          backgroundColor: '#fffde7',
          borderLeft: '6px solid #fdd835',
          borderRadius: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          📍 Tertarik dengan BYD Atto1? Kunjungi Dealer BYD BSD Serpong
          Sekarang!
        </Typography>
        <Typography variant='body1' gutterBottom>
          Ingin melihat langsung dan test drive BYD Atto1? Dealer resmi kami
          di <strong>BYD BSD Serpong</strong> siap melayani kamu. Kami juga
          menyediakan unit <strong>Denza D9</strong> dan{' '}
          <strong>Sealion 7</strong> untuk kamu yang mencari opsi lebih premium.
        </Typography>
        <Typography variant='body2' sx={{ mt: 1 }}>
          📞{' '}
          <a
            href='https://api.whatsapp.com/send?phone=6281286864825'
            target='_blank'
            rel='noopener noreferrer'
          >
            Hubungi via WhatsApp
          </a>{' '}
          atau kunjungi{' '}
          <a
            href='https://instagram.com/bydbsdserpong'
            target='_blank'
            rel='noopener noreferrer'
          >
            @bydbsdserpong
          </a>{' '}
          untuk info lengkap dan promo terbaru!
        </Typography>
      </Paper>
    </Box>
  );
}

export default ExteriorSeagull;
